import {
    type FC
} from "react";
import type ITableCellProps from "./type";
import TableCellBase from "../../internal/cell";

const TableCell: FC<ITableCellProps> = (props) => {
    return <TableCellBase
        {...props}
        kind="cell"
    />;
};
export default TableCell;
